export default __webpack_public_path__ + "static/media/section5-tablet.ad111146.png";